<template>
  <div id="order-setting" class="rounded-item shadow-md">
    <vx-card>
      <div class="setting-card-hidden">
        <div class="setting-card-scroll">
          <h4 class="text-2xl font-bold mb-5">Order Setting</h4>
          <div class="flex align-center">
            <vs-switch v-model="key_active" class="my-6" @click="updateActive"/>
            <span class="pl-5">Please press "Activate" only when you have completed all information in Setting, Services and Staff tabs.</span>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
export default {
  name: 'vs-order-setting',
  data(){
    return{
      key_active: false,
      loaded_data_num: 0,
      action_type: ''
    }
  },
  watch: {
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 1) {
          this.closeLoading();
        } else {
          this.action_type = 'Get data';
          this.openLoadingInDiv();
        }
      }
    }
  },
  methods:{
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' Active Order Online Failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.isOpenLoading = false;
      setTimeout( ()=> {
        this.$vs.loading.close('#app > .con-vs-loading')
      }, 500);
    },
     updateActive(){
      const obj = {
        key: 'config.order.web_booking.active',
        value: !this.key_active ? 1 : 0
      }
      this.action_type = 'Update';
      this.openLoadingInDiv();
      this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
        this.closeLoading();
        this.$vs.notify({
          title:'Notification',
          text:'Update Active Order Online Success',
          color:'success',
          position:'top-right'})
      }).catch(() => {
        this.closeLoading();
        this.$vs.notify({
          title:'Notification',
          text:'Update Active Order Online Failed',
          color:'danger',
          position:'top-right'})
      })
    }
  },
  created(){
    const obj = {
      key: 'config.order.web_booking.active'
    }
    this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
      this.loaded_data_num++;
      this.$emit('LoadDataComplete');
      let order = {};
      order = this.$store.getters["appSetting/keyStorage"];
      this.key_active = order.value == 1 ? true : false
    }).catch(() => {
      const obj = {
        key: 'config.order.web_booking.active',
        value : 1
      }
      this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
        this.loaded_data_num++;
        this.$emit('LoadDataComplete');
      })
    })
  }
}
</script>
